<template>
    <div ref="inputAddressDialog">
        <el-dialog
                v-model="visible"
                title="添加通訊錄"
                :width="dialogWidth"
                align-center
                destroy-on-close
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                @closed="submitClose"
        >
            <inputAddressBook @submit-success="submitSuccess" />
        </el-dialog>
    </div>

</template>

<script setup>
    import {getCurrentInstance, onMounted, ref, watch} from "vue";
    import inputAddressBook from "@/components/shopopee/card/inputAddressBook"

    const props = defineProps(["dialogVisible"])
    const emits = defineEmits(['submit-success', 'closeDialog'])

    const { proxy } = getCurrentInstance()

    const componentWidth = ref(375)
    const dialogWidth = ref("90%")
    const visible = ref(false)

    watch(() => props.dialogVisible, (newValue, oldValue) => {
        visible.value = newValue
    });

    function submitSuccess(){
        emits("submit-success")
    }

    function submitClose(){
        emits("closeDialog")
    }

    onMounted(() => {
        componentWidth.value = proxy.$refs.inputAddressDialog.offsetWidth

        if (componentWidth.value < 550){
            dialogWidth.value = "90%"
        }else{
            dialogWidth.value = "500"
        }
    })
</script>

<style scoped>

</style>